import useAuth from 'app/hooks/useAuth';

import { collection, getFirestore, onSnapshot } from 'firebase/firestore';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { userInstagramStateAtom } from '../atom';

const useInstagram = () => {
  const setInstagrams = useSetRecoilState(userInstagramStateAtom);
  const { user } = useAuth();

  useEffect(() => {
    const uid = user?.uid;
    if (!uid) return;

    const unsubscribeInstagram = onSnapshot(
      collection(getFirestore(), 'userData', uid, 'instagram'),
      (snapshot) => {
        let nInstagrams = [];
        snapshot.forEach((doc) => {
          nInstagrams.push({ ...doc.data(), id: doc.id });
        });
        setInstagrams(nInstagrams);
      }
    );

    return () => {
      unsubscribeInstagram();
    };
  }, [user?.uid]);

  return null;
};

export default useInstagram;
